import type { PaginationStyleProperty } from '../../Pagination.types';
import {
  parseValueWithUnit,
  ZERO_PIXELS,
} from '@wix/editor-elements-common-utils';

export const isDisplayed = (styleProperty: string) => styleProperty !== 'none';

export const getDisplayedValues = ({
  pageVerticalPadding,
  pageHorizontalPadding,
  buttonsVerticalPadding,
  buttonsHorizontalPadding,
  contentGap,
  navigationButtonsGap,
}: {
  pageVerticalPadding: PaginationStyleProperty['page-vertical-padding'];
  pageHorizontalPadding: PaginationStyleProperty['page-horizontal-padding'];
  buttonsVerticalPadding: PaginationStyleProperty['buttons-vertical-padding'];
  buttonsHorizontalPadding: PaginationStyleProperty['buttons-horizontal-padding'];
  contentGap: PaginationStyleProperty['content-gap'];
  navigationButtonsGap: PaginationStyleProperty['navigation-buttons-gap'];
}) => {
  const displayedPageVerticalPadding = parseValueWithUnit(pageVerticalPadding, {
    fallbackValue: ZERO_PIXELS,
  });
  const displayedPageHorizontalPadding = parseValueWithUnit(
    pageHorizontalPadding,
    {
      fallbackValue: ZERO_PIXELS,
    },
  );
  const displayedButtonsVerticalPadding = parseValueWithUnit(
    buttonsVerticalPadding,
    {
      fallbackValue: ZERO_PIXELS,
    },
  );
  const displayedButtonsHorizontalPadding = parseValueWithUnit(
    buttonsHorizontalPadding,
    {
      fallbackValue: ZERO_PIXELS,
    },
  );
  const displayedContentGap = parseValueWithUnit(contentGap, {
    fallbackValue: ZERO_PIXELS,
  });
  const displayedNavigationButtonsGap = parseValueWithUnit(
    navigationButtonsGap,
    {
      fallbackValue: ZERO_PIXELS,
    },
  );

  return {
    displayedButtonsHorizontalPadding,
    displayedButtonsVerticalPadding,
    displayedNavigationButtonsGap,
    displayedContentGap,
    displayedPageHorizontalPadding,
    displayedPageVerticalPadding,
  };
};
